import(/* webpackMode: "eager" */ "/var/www/vhosts/zoyaspantry.com.au/httpdocs/frontend/src/modules/pages/post-template.js")